import Vue from 'vue'
import Router from 'vue-router'
import converter from '@/components/page/Converter'

Vue.use(Router);
const mode = navigator.userAgent.match("Electron") ? "hash" : "history";
const router = new Router({
    mode,
    routes: [
        {
            path: '/', redirect: '/converter'
        },
        {
            path: '/converter',
            component: converter,
            name: 'converter'
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.hash.startsWith('#!')) {
        next(to.hash.slice(2));
    } else {
        next();
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js